import React from 'react';
import './input.css';
import { maskCPF, maskTelefone } from '../../utils/validation';

interface InputProps {
    placeholder?: string;
    value?: string;
    onChange?: (evt: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (evt: React.FocusEvent<HTMLInputElement>) => void;
    type?: string;
    style?: React.CSSProperties;
    error?: string;
    inputMode?: 'text' | 'numeric' | 'tel' | 'email';
    maxLength?: number;
}

const InputBase: React.FC<InputProps> = ({ placeholder, value = '', onChange = () => {}, onBlur = () => {}, error = '', inputMode, maxLength }) => {
    return (
        <div className="agendamento-input-wrapper">
            <input
                className={`agendamento-input ${error ? 'agendamento-input-error' : ''}`}
                placeholder={placeholder}
                value={value}
                type="text"
                inputMode={inputMode}
                maxLength={maxLength}
                onChange={onChange}
                onBlur={onBlur}
            />
            {error && <span className="agendamento-input-error-message">{error}</span>}
        </div>
    );
};

export const Input: React.FC<InputProps> = (props) => <InputBase {...props} />;

// Repassa o valor ja mascarado/tratado para o onChange do componente pai
const withMask =
    (mask: (value: string) => string) =>
    (onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void) =>
    (evt: React.ChangeEvent<HTMLInputElement>) => {
        const maskedEvent = {
            ...evt,
            target: { ...evt.target, value: mask(evt.target.value) },
        };
        onChange(maskedEvent as React.ChangeEvent<HTMLInputElement>);
    };

export const InputCPF: React.FC<InputProps> = ({ onChange = () => {}, ...props }) => (
    <InputBase
        {...props}
        inputMode="numeric"
        maxLength={14}
        onChange={withMask(maskCPF)(onChange)}
    />
);

export const InputTelefone: React.FC<InputProps> = ({ onChange = () => {}, ...props }) => (
    <InputBase
        {...props}
        inputMode="tel"
        maxLength={15}
        onChange={withMask(maskTelefone)(onChange)}
    />
);

export const InputEmail: React.FC<InputProps> = (props) => (
    <InputBase
        {...props}
        inputMode="email"
    />
);

export const InputNumberGympass: React.FC<InputProps> = ({ onChange = () => {}, ...props }) => (
    <InputBase
        {...props}
        inputMode="numeric"
        onChange={withMask((value) => value.replace(/\D/g, '').slice(0, 13))(onChange)}
    />
);
